import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PaymentBatch,
  PaymentBatchPayload
} from '../models/payment-batches.model';

@Injectable({ providedIn: 'root' })
export class PaymentBatchService {
  private readonly baseUrl = 'api/Payments/batches';

  private readonly http = inject(HttpClient);

  create(payload: PaymentBatchPayload): Observable<PaymentBatch> {
    return this.http.post<PaymentBatch>(this.baseUrl, payload);
  }

  get(batchId: string): Observable<PaymentBatch> {
    return this.http.get<PaymentBatch>(`${this.baseUrl}/${batchId}`);
  }

  process(batchId: string): Observable<PaymentBatch> {
    return this.http.post<PaymentBatch>(
      `${this.baseUrl}/${batchId}/process`,
      {}
    );
  }
}
